import { render, staticRenderFns } from "./cModalProduct.vue?vue&type=template&id=3712a144&scoped=true"
import script from "./cModalProduct.vue?vue&type=script&lang=js"
export * from "./cModalProduct.vue?vue&type=script&lang=js"
import style0 from "./cModalProduct.vue?vue&type=style&index=0&id=3712a144&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3712a144",
  null
  
)

export default component.exports